import { render, staticRenderFns } from "./FotoAvatar.vue?vue&type=template&id=4e8a297d&scoped=true"
import script from "./FotoAvatar.vue?vue&type=script&lang=js"
export * from "./FotoAvatar.vue?vue&type=script&lang=js"
import style0 from "./FotoAvatar.vue?vue&type=style&index=0&id=4e8a297d&prod&scoped=true&lang=stylus"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e8a297d",
  null
  
)

export default component.exports